import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDiscordIntegration, LazyEmailIntegration, LazyGoogleSheetsIntegration, LazySlackIntegration, LazyWebhookIntegration, LazyZapierIntegration, LazyGoogleSheetsIntegrationActions, LazyIntegrationCard, LazyIntegrationEventsModal, LazyIntegrationListOption, LazyIntegrationModal, LazyIntegrationWrapper, LazyNotificationsMessageActions, LazyCheckboxInput, LazyCodeInput, LazyColorInput, LazyDateInput, LazyFileInput, LazyFlatSelectInput, LazyImageInput, LazyMatrixInput, LazyMentionInput, LazyPhoneInput, LazyRatingInput, LazyRichTextAreaInput, LazyScaleInput, LazySelectInput, LazySignatureInput, LazySliderInput, LazyTextAreaInput, LazyTextBlock, LazyTextInput, LazyToggleSwitchInput, LazyVForm, LazyCameraUpload, LazyCheckboxIcon, LazyFormSubmissionFormatter, LazyInputHelp, LazyInputLabel, LazyInputWrapper, LazyMentionDropdown, LazyQuillyEditor, LazyRadioButtonIcon, LazyUploadedFile, LazyVCheckbox, LazyVSelect, LazyUseFormInput, LazyAlert, LazyAlertError, LazyAlertSuccess, LazyHasError, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["DiscordIntegration", LazyDiscordIntegration],
["EmailIntegration", LazyEmailIntegration],
["GoogleSheetsIntegration", LazyGoogleSheetsIntegration],
["SlackIntegration", LazySlackIntegration],
["WebhookIntegration", LazyWebhookIntegration],
["ZapierIntegration", LazyZapierIntegration],
["GoogleSheetsIntegrationActions", LazyGoogleSheetsIntegrationActions],
["IntegrationCard", LazyIntegrationCard],
["IntegrationEventsModal", LazyIntegrationEventsModal],
["IntegrationListOption", LazyIntegrationListOption],
["IntegrationModal", LazyIntegrationModal],
["IntegrationWrapper", LazyIntegrationWrapper],
["NotificationsMessageActions", LazyNotificationsMessageActions],
["CheckboxInput", LazyCheckboxInput],
["CodeInput", LazyCodeInput],
["ColorInput", LazyColorInput],
["DateInput", LazyDateInput],
["FileInput", LazyFileInput],
["FlatSelectInput", LazyFlatSelectInput],
["ImageInput", LazyImageInput],
["MatrixInput", LazyMatrixInput],
["MentionInput", LazyMentionInput],
["PhoneInput", LazyPhoneInput],
["RatingInput", LazyRatingInput],
["RichTextAreaInput", LazyRichTextAreaInput],
["ScaleInput", LazyScaleInput],
["SelectInput", LazySelectInput],
["SignatureInput", LazySignatureInput],
["SliderInput", LazySliderInput],
["TextAreaInput", LazyTextAreaInput],
["TextBlock", LazyTextBlock],
["TextInput", LazyTextInput],
["ToggleSwitchInput", LazyToggleSwitchInput],
["VForm", LazyVForm],
["CameraUpload", LazyCameraUpload],
["CheckboxIcon", LazyCheckboxIcon],
["FormSubmissionFormatter", LazyFormSubmissionFormatter],
["InputHelp", LazyInputHelp],
["InputLabel", LazyInputLabel],
["InputWrapper", LazyInputWrapper],
["MentionDropdown", LazyMentionDropdown],
["QuillyEditor", LazyQuillyEditor],
["RadioButtonIcon", LazyRadioButtonIcon],
["UploadedFile", LazyUploadedFile],
["VCheckbox", LazyVCheckbox],
["VSelect", LazyVSelect],
["UseFormInput", LazyUseFormInput],
["Alert", LazyAlert],
["AlertError", LazyAlertError],
["AlertSuccess", LazyAlertSuccess],
["HasError", LazyHasError],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
